import { render, staticRenderFns } from "./allSurgeresInvoices.vue?vue&type=template&id=cac70982&scoped=true"
import script from "./allSurgeresInvoices.vue?vue&type=script&lang=js"
export * from "./allSurgeresInvoices.vue?vue&type=script&lang=js"
import style0 from "./allSurgeresInvoices.vue?vue&type=style&index=0&id=cac70982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac70982",
  null
  
)

export default component.exports